import type { HTMLAttributes } from 'react';

import clsx from 'clsx';

import styles from './Menu.module.scss';
import type { Visibility } from './types';

type Props = HTMLAttributes<HTMLElement> & {
  visibility?: Visibility;
};

const Title = ({ children, className, visibility, ...rest }: Props) => {
  return (
    <strong className={clsx(styles.title, className)} data-visibility={visibility} {...rest}>
      {children}
    </strong>
  );
};

export default Title;
